import { theme } from '../../../theme';

export const TabPanelStyle = {
    tabPanel: {
        justifyContent: 'flex-start',
        flex: '1',
    }
}